'use strict';

var Misc = require('utils/misc');

var EventLogItem = Marionette.ItemView.extend({
    template: require('components/devices/templates/common/event_log_item'),

    serializeData: function () {
        var data = Marionette.ItemView.prototype.serializeData.apply(this);
        data[data.item_type] = true;
        switch (data.item_type) {
            case 'device_status':
            case 'device_ok':
                data.errors = Misc.getErrorsFromStatus(data.ref_id, data.category, data.custom_data);
                break;
        }

        return data;
    },
});

module.exports = EventLogItem;
